<template>
  <span :class="{'text-success': state === 'SUCCESS', 'text-danger': state === 'ERROR'}">
    {{ state.replace(/_/g, ' ') }}
  </span>
</template>

<script>
import axios from "axios";

const STATES = {
  IDLE: 'IDLE',
  PINGING: 'PINGING',
  NO_RESPONSE: 'NO_RESPONSE',
  SUCCESS: 'SUCCESS',
  INVALID_DATA: 'INVALID_DATA',
  ERROR: 'ERROR',
}
export default {
  name: "SocketsTest",
  data() {
    return {
      state: STATES.IDLE,
      expectedValue: null,
    }
  },
  beforeDestroy() {
    Echo.leave('prosperity');
  },
  mounted() {
    Echo.private('prosperity')
        .listen('SocketTest', (response) => {
          if (this.expectedValue === response.data) {
            this.state = STATES.SUCCESS;
            return;
          }
          console.log(response);
          this.state = STATES.INVALID_DATA;
        }).error((data) => {
      console.log(data);
      this.state = STATES.ERROR;
    })
    try {
      axios.post('/admin/systemSettings/testSocket').then((response) => {
        this.state = STATES.PINGING;
        this.expectedValue = response.data.expectedValue;
        setTimeout(() => {
          if (this.state !== STATES.PINGING) {
            return;
          }
          this.state = STATES.NO_RESPONSE;
        }, 10000)
      }).catch((response) => {
        console.log(response);
        this.state = STATES.ERROR;
      })
    } catch (e) {
      console.log(e);
      this.state = STATES.ERROR;
    }
  },
}
</script>

<style scoped>

</style>